import { styled } from '@shared/ui';

const Root = styled('div')({
  padding: 'var(--qhs-sp-2) 0',
});

const Row = styled('div')({
  display: 'flex',
  gap: 'var(--qhs-sp-5)',
  alignItems: 'center',
  padding: 'var(--qhs-sp-3)',
  borderBottom: '1px solid var(--qhs-border)',
  '&:last-of-type': { borderBottom: 'none' },
});

const Cell = styled('div')({ flex: 1 });

// Same shimmer treatment as the Breadcrumbs skeleton, stretched to
// fill a table cell.
export const ShimmerBar = styled('span')({
  display: 'block',
  width: '100%',
  maxWidth: 160,
  height: 14,
  borderRadius: 4,
  background:
    'linear-gradient(90deg, var(--qhs-surface-hover) 0%, var(--qhs-border) 50%, var(--qhs-surface-hover) 100%)',
  backgroundSize: '160px 100%',
  backgroundRepeat: 'no-repeat',
  animation: 'qhs-journey-shimmer 1.4s ease-in-out infinite',
  '@keyframes qhs-journey-shimmer': {
    '0%': { backgroundPosition: '-160px 0' },
    '100%': { backgroundPosition: 'calc(160px + 100%) 0' },
  },
});

// Shimmer placeholder shaped like the table it replaces, so the panel
// keeps its height while the first page loads instead of collapsing.
const TableSkeleton = ({ columns = 5, rows = 5 }) => (
  <Root>
    {Array.from({ length: rows }, (_, rowIndex) => (
      <Row key={rowIndex}>
        {Array.from({ length: columns }, (_, colIndex) => (
          <Cell key={colIndex}>
            <ShimmerBar />
          </Cell>
        ))}
      </Row>
    ))}
  </Root>
);

export default TableSkeleton;
